import React from "react";
import Wprr from "wprr/Wprr";

import ManipulationBaseObject from "wprr/manipulation/ManipulationBaseObject";

import WprrContext from "wprr/reference/WprrContext";
import Dbm from "dbm";

//import ReferenceExporter from "wprr/reference/ReferenceExporter";
export default class ReferenceExporter extends ManipulationBaseObject {

	constructor(aProps) {
		super(aProps);
	}
	
	getReferences() {
		return this.getSourcedProp("references");
	}
	
	_removeUsedProps(aReturnObject) {
		//console.log("wprr/reference/ReferenceExporter::removeUsedProps");
		
		delete aReturnObject["references"];
		
		return aReturnObject;
	}
	
	_renderMainElement() {
		let clonedElements = super._renderMainElement();
		
		let references = this.getSourcedProp("references");
		let values = {};
		for(let objectName in references._objects) {
			values[objectName] = references._objects[objectName];
		}
		values["references"] = references;
		
		return React.createElement(Dbm.react.context.AddContextVariables, {"values": values}, clonedElements);
	}
}